import { Locale } from '@doordash/lib-i18n';
var SUPPORTED_LOCALES = [
    Locale.EN_AU,
    Locale.EN_CA,
    Locale.EN_NZ,
    Locale.EN_US,
    Locale.FR_CA,
    Locale.ES_US,
    Locale.JA_JP,
    Locale.DE_DE,
];
// locale is specific lang-REGION (ie: en-US, es-US)
var hasLocaleInPath = function (pathname) {
    return /\/[a-z]{2}-[A-Z]{2}(\/)?/.test(pathname);
};
var getNormalizedPathAndLocale = function (pathname) {
    // If path is '/' just return the same.
    if (pathname && pathname !== '/') {
        var strippedPath = pathname;
        var matchedLocale = null;
        for (var i = 0; i < SUPPORTED_LOCALES.length; i++) {
            if (pathname.indexOf("/" + SUPPORTED_LOCALES[i]) !== -1) {
                matchedLocale = SUPPORTED_LOCALES[i];
                strippedPath = strippedPath.replace("/" + matchedLocale, '');
                break;
            }
        }
        return {
            normalizedPath: strippedPath || '/',
            localeInPath: matchedLocale,
        };
    }
    return {
        normalizedPath: pathname,
    };
};
export { hasLocaleInPath, getNormalizedPathAndLocale };
